import { ApiError } from '../../shared/api/client';
import { describeApiFailure } from '../../shared/ui';
import { NotAnAdministrator } from './session';

/** Текст отказа входа для человека. Класс отказа решает клиент API; здесь только слова. */
export function describeLoginFailure(error: unknown): string {
  if (error instanceof NotAnAdministrator) {
    return error.message;
  }
  if (error instanceof ApiError) {
    if (error.status === 401) {
      return 'Неверный email или пароль.';
    }
    if (error.status === 429) {
      return 'Слишком много попыток. Подождите минуту и попробуйте снова.';
    }
    return describeApiFailure(error);
  }
  return 'Войти не удалось.';
}
